import Checkmark from "@/components/common/icons/checkmark"
import cx from "classnames"
import { AnimatePresence, motion } from "framer-motion"

function Food({ label, icon, checked, onChange }) {
  return (
    <label
      className={cx(
        "relative flex items-center bg-white h-14 w-auto rounded-[64px] px-4 cursor-pointer border-2 border-summer-green-50 transition-colors duration-200 hover:border-summer-green-100",
        { "bg-transparent border-summer-green-100": checked }
      )}>
      <input
        checked={checked}
        value={label}
        type="checkbox"
        className="opacity-0 absolute"
        onChange={onChange}
      />
      {icon}
      <span className="text-sm whitespace-nowrap select-none">{label}</span>
      <AnimatePresence>
        {checked && (
          <motion.div
            initial={{ scale: 0, opacity: 0.5 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0, opacity: 0 }}
            className="absolute -top-2 -right-2 flex items-center
            justify-center w-6 h-6 bg-summer-green-100 rounded-full">
            <Checkmark className="w-3" />
          </motion.div>
        )}
      </AnimatePresence>
    </label>
  )
}

export default Food
